module.exports = __webpack_public_path__ + "static/media/Fundiin.98474d61.jpg";